import { memo } from 'react'
import { CustomChip } from '../CustomChip/CustomChip'

export const ChipResetFilter = memo(({ handleReset }: { handleReset: () => void }) =>
    <CustomChip onClick={handleReset}>Reset Filter</CustomChip>
)
